import React from 'react'

import Svg, { Path } from 'react-native-svg'

const ZetLogo = ({ width = 64, height = 32, color = '#fff' }) => {
  return (
    <Svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <Path
        d="M31.7615 19.3844V18.3584H40.0073L37.4888 12.9779H31.7615V11.9519H37.0092L34.2217 6H26.3275V25.3363H43.2759L40.4892 19.3844H31.7615Z"
        fill={`${color}`}
      />
      <Path
        d="M35.7257 6L38.4283 11.9519H44.6428V25.3363H50.58V11.9519H56.7437V6H35.7257Z"
        fill={`${color}`}
      />
      <Path
        d="M8 11.9519H16.1822L8 19.3844V25.3363H24.9705V19.3844H16.786L24.9705 11.9519V6H8V11.9519Z"
        fill={`${color}`}
      />
    </Svg>
  )
}

export default ZetLogo
